import { render, staticRenderFns } from "./comp-details-modal.vue?vue&type=template&id=1755f598&scoped=true"
import script from "./comp-details-modal.vue?vue&type=script&lang=js"
export * from "./comp-details-modal.vue?vue&type=script&lang=js"
import style0 from "./comp-details-modal.vue?vue&type=style&index=0&id=1755f598&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1755f598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1755f598')) {
      api.createRecord('1755f598', component.options)
    } else {
      api.reload('1755f598', component.options)
    }
    module.hot.accept("./comp-details-modal.vue?vue&type=template&id=1755f598&scoped=true", function () {
      api.rerender('1755f598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comp-details-modal.vue"
export default component.exports